import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";
import { randomId } from "@/shared/utils/randomId";

export type TrayPickupStatus = "ReadyForPickup" | "Assigned" | "PartiallyCollected" | "Collected" | "PartiallyReceived" | "Received" | "Discrepancy" | "Cancelled";

export interface TrayPickupDto {
  id: string;
  orderId: string;
  orderNumber: string;
  dispatchRecordId: string;
  dispatchNumber: string;
  customerId: string;
  customerName: string;
  customerPhone?: string;
  location?: string;
  latitude?: number;
  longitude?: number;
  quantityDeclaredReady: number;
  quantityRemainingReady: number;
  quantityCollectedGood: number;
  quantityCollectedDamaged: number;
  quantityNotFound: number;
  quantityReceivedGood: number;
  quantityReceivedDamaged: number;
  quantityReceiptVariance: number;
  orderTrayObligationOutstanding: number;
  readinessSource: "Farmer" | "Sales";
  readyAt: string;
  returnDueAt: string;
  isOverdue: boolean;
  deliveryPlanId?: string;
  deliveryPlanName?: string;
  driverId?: string;
  driverName?: string;
  driverUserId?: string;
  collectedAt?: string;
  receivedAt?: string;
  status: TrayPickupStatus;
}

export interface TrayPickupListResult { items: TrayPickupDto[]; totalCount: number; pageNumber: number; pageSize: number; totalPages: number; }

export const trayPickupsApi = {
  list: async (params?: { status?: TrayPickupStatus; search?: string; includeCompleted?: boolean; pageNumber?: number; pageSize?: number }) =>
    (await apiClient.get<ApiResponse<TrayPickupListResult>>("/tray-pickups", { params })).data.data,
  declare: async (orderId: string, quantityReady: number, notes?: string) =>
    (await apiClient.post<ApiResponse<TrayPickupDto>>("/tray-pickups/readiness", { orderId, quantityReady, notes })).data.data,
  assign: async (id: string, driverId: string, deliveryPlanId?: string) =>
    (await apiClient.post<ApiResponse<TrayPickupDto>>(`/tray-pickups/${id}/assign`, { driverId, deliveryPlanId: deliveryPlanId || null })).data.data,
  receive: async (id: string, goodQuantity: number, damagedQuantity: number, notes?: string) =>
    (await apiClient.post<ApiResponse<TrayPickupDto>>(`/tray-pickups/${id}/receive`, {
      goodQuantity, damagedQuantity, notes, idempotencyKey: randomId(),
    })).data.data,
};
